import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgClockHistoryCircleLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M12 6a1 1 0 0 1 1 1v5.586l2.036 2.035a1 1 0 1 1-1.415 1.415l-2.328-2.329A1 1 0 0 1 11 13V7a1 1 0 0 1 1-1M12.254 3.002a1 1 0 0 1 .028-2c3.202.046 5.943.887 7.886 2.83 2 2 2.832 4.844 2.832 8.168 0 3.247-.794 6.036-2.696 8.03a1 1 0 1 1-1.447-1.382C20.28 17.158 21 14.948 21 12c0-3.017-.754-5.262-2.246-6.754-1.45-1.45-3.61-2.203-6.5-2.244M8.022 1.484a1 1 0 0 1 .526 1.93 9 9 0 0 0-.398.117 1 1 0 0 1-.61-1.904q.239-.077.482-.143M3.697 3.97a1 1 0 0 1 1.446 1.381 6.7 6.7 0 0 0-1.176 1.707 1 1 0 1 1-1.798-.876A8.7 8.7 0 0 1 3.697 3.97M1.067 10.423a1 1 0 1 1 1.992.176Q3 11.27 3 12q0 2.192.531 3.85a1 1 0 0 1-1.904.61C1.197 15.116 1 13.617 1 12q0-.81.067-1.577M3.97 20.304a1 1 0 1 1 1.382-1.447C6.842 20.28 9.052 21 12 21q2.193 0 3.85-.532a1 1 0 0 1 .61 1.905c-1.344.43-2.843.627-4.46.627-3.247 0-6.037-.794-8.03-2.696'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgClockHistoryCircleLine)
export default ForwardRef
